import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import axios from 'axios';
import { API, BACKEND_URL } from '@/constants/data';

const PortfolioSection = () => {
  const [events, setEvents] = useState([]);
  useEffect(() => { axios.get(`${API}/gallery`).then(r => setEvents(r.data)).catch(console.error); }, []);

  if (events.length === 0) return null;

  return (
    <section id="portfolio" className="py-20 lg:py-28 bg-white" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {events.map((event, i) => (
            <motion.div key={event.id}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              data-testid={`portfolio-item-${i}`}
              className="group relative aspect-[4/3] overflow-hidden rounded-2xl shadow-lg cursor-pointer">
              <img src={event.images?.[0]?.startsWith('/') ? `${BACKEND_URL}${event.images[0]}` : event.images?.[0]}
                alt={event.title}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0A2463]/90 via-[#0A2463]/20 to-transparent opacity-60 group-hover:opacity-90 transition-opacity" />
              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-2 group-hover:translate-y-0 transition-transform">
                <span className="text-[#00A8E8] text-xs font-bold uppercase tracking-wider font-body">{event.category}</span>
                <h3 className="font-heading text-2xl text-white mt-1 uppercase">{event.title}</h3>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PortfolioSection;
